import React from 'react';
import './index.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const HelperFunction = (props) => {
    const { message = '', placement = 'right' } = props;
    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip id="tooltip">
                    <p className="pt-1 pb-0">{message}</p>
                </Tooltip>
            }
        >
            <i className="fas fa-info-circle pr-2 icon-class" />
        </OverlayTrigger>
    );
};

export default HelperFunction;
